import { Session } from './session';
import createOrUpdateCsrSessionCookie from './createOrUpdateCsrSessionCookie';
import getOrInitializeCsrSession from './getOrInitializeCsrSession';

type DeepWriteable<T> = { -readonly [P in keyof T]: DeepWriteable<T[P]> };

export type FieldsToUpdate = Partial<Omit<Session, 'guid'>>;

const updateCsrSession = (fieldsToUpdate: FieldsToUpdate): Session => {
  const session = getOrInitializeCsrSession();
  const editableSession: DeepWriteable<Session> = {
    ...session,
    ...fieldsToUpdate
  };
  createOrUpdateCsrSessionCookie(editableSession);

  return editableSession;
};

export default updateCsrSession;
